<ng-container *ngrxLet="cachedRegistrations$ as cachedRegistrations">
    @if (cachedRegistrations?.length) {
        <button
            priva-button
            class="download-button"
            iconState="left"
            iconClass="fa-regular fa-download"
            (click)="downloadRegistrations()"
            data-test="registrations-download-btn"
        >
            {{ 'SETTINGS.TITLE.DOWNLOAD_CACHED_REGISTRATIONS' | translate }}
        </button>
    }
    <priva-table
        [rows]="cachedRegistrations ?? []"
        [disableSelect]="false"
        type="separate"
        class="registration-table"
    >
        <ng-template
            priva-table-column="{{ 'TABLE.CACHED_REGISTRATIONS.HEADER.REGISTRATIONTIME' | translate }}"
            let-item="row"
        >
            {{ asRegistration(item).registrationTimestamp | date: 'short' }}
        </ng-template>
        <ng-template
            priva-table-column="{{ 'TABLE.CACHED_REGISTRATIONS.HEADER.REGISTRATIONTYPE' | translate }}"
            let-item="row"
        >
            {{ RegistrationType[asRegistration(item).registrationType] }}
        </ng-template>
        <ng-template
            priva-table-column="{{ 'TABLE.CACHED_REGISTRATIONS.HEADER.ACTIVITYNUMBER' | translate }}"
            let-item="row"
        >
            {{ asRegistration(item).activityNumber }}
        </ng-template>
        <ng-template
            priva-table-column="{{ 'TABLE.CACHED_REGISTRATIONS.HEADER.LOCATIONNUMBER' | translate }}"
            let-item="row"
        >
            @for (rowRegistration of asRegistration(item).rowRegistrations; track rowRegistration.rowNumber) {
                <span>
                    {{ rowRegistration.rowNumber }}
                    <priva-status-circle [status]="getLocationStatus(rowRegistration.registrationStatus)" />
                </span>
            }
        </ng-template>
        <ng-template
            priva-table-column="{{ 'TABLE.CACHED_REGISTRATIONS.HEADER.EMPLOYEENUMBER' | translate }}"
            let-item="row"
        >
            {{ asRegistration(item).employeeNumber }}
        </ng-template>
    </priva-table>
</ng-container>
